export const app_exists_not_exists_en = {
  true: 'Exists',
  false: 'Not Exists',
};
